"use client"

import { ArrowLeft, User } from "lucide-react"
import ConnectionStatus from "./ConnectionStatus"

export default function ChatHeader({ activeChatData, isConnected, setShowChatsView }) {
  return (
    <div className="p-4 border-b border-gray-200 flex items-center bg-[var(--navy-blue-light)] h-19">
      <button onClick={() => setShowChatsView(true)} className="mr-4 p-2 rounded-full hover:bg-gray-100 md:hidden">
        <ArrowLeft className="w-5 h-5" />
      </button>
      <div className="flex items-center">
        {activeChatData?.contact?.avatar ? (
          <img
            src={activeChatData.contact.avatar || "/placeholder.svg?height=40&width=40"}
            alt={activeChatData.contact.name}
            className="w-10 h-10 rounded-full object-cover"
          />
        ) : (
          <div className="w-10 h-10 rounded-full bg-gray-300 flex items-center justify-center">
            <User className="w-5 h-5 text-gray-600" />
          </div>
        )}
        <h2 className="ml-3 font-semibold text-white">{activeChatData?.contact?.name || "Usuario"}</h2>
      </div>
      <ConnectionStatus isConnected={isConnected} />
    </div>
  )
}

